<template lang="pug">
  include ../mixins
  div
    row(space="sm")
      cell(:cols="input.cols" v-for="(input, index) in formModel" :key="index")
        +b.form.pos--relative.ma--bottom_sm
          template(v-if="input.view === 'input'")
            component(
              :is="input.component"
              :rules="input.rules"
              :type="input.type"
              :inputmode="input.type"
              :label-class="input.labelClass"
              :input-label="input.inputLabel"
              :class-name="input.className"
              :placeholder="input.placeholder"
              v-model="formdata[input.model]"
              :required="input.required"
              :name="input.name"
              :format="input.format"
              :mask="input.mask"
              :value-type="input.valueType"
              :range="input.range || false"
              :disabled-date="input.disabledDate"
              :disabled="input.isDisabled"
              @input="$emit('update')"
              @update="$emit('update', $event)"
              @update-date="$emit('update-date', $event)"
            )
          div(
            v-if="input.view === 'multiselect'"
            v-tooltip.hover.ios="input.tooltip && options[input.options].length === 0 ? {content: input.tooltip } : { visible: false }"
          )
            component(
              :is="input.component"
              :rules="input.rules"
              :options="options[input.options]"
              :class="input.className"
              :placeholder="input.placeholder"
              :track-by="input.trackBy"
              :label-class="input.labelClass"
              :input-label="input.inputLabel"
              :preselect-first="input.preselectFirst"
              :allowEmpty="input.allowEmpty"
              :label="input.label"
              :name="input.name"
              :disabled="options[input.options].length === 0"
              :multiple="input.multiple || false"
              :groupValues="input.groupValues"
              :groupLabel="input.groupLabel"
              :groupSelect="input.groupSelect"
              :close-on-select="input.closeOnSelect"
              v-model="formdata[input.model]"
              @input="input.handler"
            )
      slot
</template>

<script>
export default {
  name: 'form-generator',
  props: {
    formModel: Array,
    options: Object,
    formdata: Object,
  },
}
</script>
